import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { FiKey, FiLogOut } from 'react-icons/fi';
import authService from '../services/authService';

// Minimal shell for role === 'superadmin'. Superadmin manages all companies/tenants,
// not one specific company, so none of the module-gated sidebar/pinned-actions make
// sense here — hasModule() always returns true for this role, which would otherwise
// silently re-enable Start Production/Orders/Messaging with no real company context
// behind them. Matches the old Navbar's minimal two-item branch (Super Admin + Logout).
export default function SuperAdminShell() {
  const handleLogout = () => {
    authService.clearToken();
    window.location.href = '/';
  };

  return (
    <>
      <div
        className="app-chrome d-flex align-items-center"
        style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 'var(--topbar-height)', background: '#1b2638', zIndex: 1000, padding: '0 16px', gap: 12 }}
      >
        <span className="text-white" style={{ fontSize: 16, fontWeight: 700 }}>quickLOG</span>
        <div className="ms-auto d-flex align-items-center gap-2">
          <Link className="btn btn-sm btn-outline-warning fw-semibold d-flex align-items-center gap-2" to="/superadmin">
            <FiKey size={14} /> Super Admin
          </Link>
          <button className="btn btn-sm btn-outline-danger d-flex align-items-center gap-2" onClick={handleLogout}>
            <FiLogOut size={14} /> Logout
          </button>
        </div>
      </div>
      <div style={{ paddingTop: 'var(--topbar-height)' }}>
        <Outlet />
      </div>
    </>
  );
}
